const sizes = {
  tablet: '600px',
  desktop: '1200px',
};

export const media = {
  tablet: `(min-width: ${sizes.tablet})`,
  desktop: `(min-width: ${sizes.desktop})`,
};
